(() => {
  function shuffleCartCrossSell(root = document) {
    root.querySelectorAll(".cart-collection .product-grid").forEach((grid) => {
      const products = Array.from(grid.children).filter((item) =>
        item.classList.contains("grid-item")
      );

      for (let index = products.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [products[index], products[randomIndex]] = [products[randomIndex], products[index]];
      }

      products.forEach((product) => grid.appendChild(product));
    });
  }

  document.addEventListener("DOMContentLoaded", () => shuffleCartCrossSell());
  document.addEventListener("cart:drawer:open", (event) => {
    shuffleCartCrossSell(event.detail?.drawer || document);
  });
})();
